export const RECENT_PROJECTS = [
  {
    meta: "10 ads · Oct 6, 2026",
    thumbnail: { background: "#f4d9e3", color: "#1b1b1b", text: "Sale" },
    title: "Spring sale, dog supplements",
  },
  {
    meta: "10 ads · Sep 29, 2026",
    thumbnail: { background: "#5b35e8", color: "#ffd84d", text: "20%" },
    title: "Retargeting, 20% off",
  },
  {
    meta: "10 ads · Sep 22, 2026",
    thumbnail: { background: "#ffffff", color: "#f2a65a", text: "“" },
    title: "Customer reviews",
  },
];

export const STEPS = [
  {
    body: "Write what you want to see and upload your logo, product shots or photos.",
    title: "Describe it",
  },
  {
    body: "Browse real examples and choose the looks you want us to build from.",
    title: "Pick your styles",
  },
  {
    body: "Mark up anything you want changed, then download and run them.",
    title: "Refine and download",
  },
];
